/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Deck_Submission_RequiredInputs */



/**
* | output |
* | --- |
* | "Decklist required" |
*
* @param {Tournaments_Lib_Deck_Submission_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_deck_submission_required = /** @type {((inputs?: Tournaments_Lib_Deck_Submission_RequiredInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Deck_Submission_RequiredInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Deckliste erforderlich")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Decklist obligatoire")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("必须提交卡组表")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("必須提交牌組清單")
	if (locale === "ko") return /** @type {LocalizedString} */ ("덱 목록 필수")
	return /** @type {LocalizedString} */ ("Decklist required")
});